<template>
    <div class="box">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl ">
                    Add Notes for {{userInfo.name}} {{userInfo.last_name}}
                </div>
                <div class="switch-tabs">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a
                                :class="{ 'active': this.activeTab === 'users' }"
                                class="nav-link"
                                href="javascript:void(0)"
                                @click="switchList('users')"
                            > User Note</a>
                        </li>
                        <li
                            class="nav-item"
                            v-show="viewAdminsNotes"
                        >
                            <a
                                :class="{ 'active': this.activeTab === 'admins' }"
                                class="nav-link"
                                href="javascript:void(0)"
                                @click="switchList('admins')"
                            >Admin Note</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="user-note" role="tabpanel" aria-labelledby="tab-12">
                    <div class="form mt-3">
                        <div class="row mb-3">
                            <div class="col-md-12">
                                <div class="form-group form-group-1 mb-3">
                                    <label for="" class="form-label">Notes</label>
                                    <textarea
                                        style="width: 100%; height: 150px; overflow-y: scroll;"
                                        type="text"
                                        class="form-control"
                                        v-model="newComment"
                                    ></textarea>
                                </div>
                                <div class="col-12 pr-0">
                                    <div class="btns-wrap" style="justify-content: flex-end;">
                                        <button
                                            class="btn btn--secondary w-100 w-sm-auto "
                                            @click="addNewComment"
                                        >Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <h6>History</h6>
                                <div class="history-messages">
                                    <div class="text-scroll">
                                        <div class="todo-comments-block">

                                            <div class="comment-item"
                                                 v-for="comment in listOfComments"
                                                 :key="comment.id"
                                            >
                                                <div
                                                    class="avatar"
                                                    :style="{'background-image': comment.author.avatar ? getNameOfAvatar(comment.author.avatar): 'url(/img/svg/emptyAvatar.png)'}"
                                                ></div>
                                                <div class="item-inner">

                                                    <div class="date-time">
                                                        {{formatDate(comment.created_at)}}
                                                    </div>
                                                    <div class="item-inner-content">
                                                        <div class="item-inner-content-text">
                                                            <div class="item-ttl">
                                                                <h5>{{comment.author.name}} {{comment.author.last_name}}</h5>
                                                            </div>
                                                            <div class="form-group form-group-1 mb-0"
                                                                 v-if="activeComment.id === comment.id"
                                                            >
                                                                <textarea
                                                                    v-model="comment.comment"
                                                                    class="form-control">
                                                                </textarea>
                                                            </div>
                                                            <p v-else>
                                                                <pre style="white-space: pre-wrap; font-family: 'Open Sans', sans-serif; font-size: 14px;">{{ comment.comment }}</pre>
                                                            </p>
                                                        </div>
                                                        <div class="action-block">
                                                            <a href="javascript:void(0)"
                                                               v-if="viewAdminsNotes"
                                                               v-show="activeComment.id !== comment.id"
                                                               class="edit-link"
                                                               @click="changeNotesType(comment.id)"
                                                            ><img src="/img/svg/icons-arrpow.svg" alt="">
                                                            </a>
                                                            <a href="javascript:void(0)"
                                                               v-if="activeComment.id === comment.id"
                                                               class="img-btn edit-link ml-2"
                                                               @click="saveComment(comment)"
                                                            ><img src="/img/svg/check-5.svg" alt="save"></a>

                                                            <a href="javascript:void(0)"
                                                               v-else
                                                               v-show="editingNote"
                                                               class="img-btn edit-link ml-2"
                                                               @click="editComment(comment)"
                                                            ><img src="/img/svg/icons-pen.svg" alt="edit">
                                                            </a>
                                                            <button
                                                                v-show="activeComment.id !== comment.id"
                                                                class="img-btn delete-link"
                                                                @click="showDeleteModal(comment.id, 'notes')"
                                                            ><img src="/img/svg/on.svg" alt=""></button>

                                                            <ActionModal confirm-text="Yes"
                                                                         reject-text="No"
                                                                         :modalId="getDeleteModalId(comment.id, 'notes')"
                                                                         @confirm="deleteComment(comment.id)">
                                                                <template #body>
                                                                    <div class="text-center mb-4">
                                                                        <h4>
                                                                            Are you sure you want <br> to delete this item?
                                                                        </h4>
                                                                    </div>
                                                                </template>
                                                            </ActionModal>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import ApplicantsServices from "../services/ApplicantsServices";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import StyleHandler from "../../../../../../resources/js/mixins/StyleHandler";

export default {
    name: 'Notes',
    components: {ActionModal},
    props: {
        userInfo: {
            type: Object
        },
        viewAdminsNotes: Boolean,
        editingNote: Boolean,
    },
    mixins: [ DateConverter, ModalHandler, StyleHandler],
    data() {
        return {
            activeTab: null,
            listOfComments: this.userInfo.comments ?? [],
            activeComment: {},
            newComment: null,
            typeOfUser: 'user'
        }
    },
    methods: {
        async changeNotesType(id) {
            this.$showLoadingMessage()
            try {
                await ApplicantsServices.transferNote(id)
                this.$showSuccessMessage('The note was transferred')
                setTimeout(()=> {
                    this.reloadPage()
                }, 1000)

            } catch (e) {
                this.$showErrorMessage('The note was not transferred. Please try again')
            }
        },
        async addNewComment() {
            if (!this.newComment || this.newComment.trim() ===  '') {
                this.$showErrorMessage('Your note is empty')
            } else {
                this.$showLoadingMessage()
                try {
                    const {data: response} = await ApplicantsServices.addNewComment(this.userInfo.id, this.newComment, this.type)
                    this.listOfComments.unshift(response)
                    this.newComment = ''
                    this.$showSuccessMessage('New comment was added')
                } catch (e) {
                    this.$showErrorMessage('Your comment was not added. Please try again.');
                }
            }
        },
        async deleteComment(id) {
            this.$showLoadingMessage();
            this.listOfComments= this.listOfComments.filter((comment) => comment.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await ApplicantsServices.deleteComment(id)
            } catch (error) {
                this.$showErrorMessage('This comment was not deleted. Please try again');
            }
        },
        editComment(comment) {
            this.activeComment = comment
        },
        async saveComment(comment) {
            if (!comment.comment || comment.comment.trim() === '') {
                this.$showErrorMessage('Your comment is empty')
            } else  {
                this.$showLoadingMessage()
                try {
                    await ApplicantsServices.updateComment(comment.id, comment.comment, this.type);
                    this.activeComment = {}
                    this.$showSuccessMessage('Your comment was updated!')
                } catch (e) {
                    this.$showErrorMessage('Your comment was not updated. Please try again.');
                }
            }
        },
        switchList(tab) {
            this.activeTab = tab
            if (tab === 'users') {
                this.type = 'admin'
                this.listOfComments = this.userInfo.user_comments
            } else if(tab === 'admins') {
                this.type = 'master-admin'
                this.listOfComments =  this.userInfo.admin_comments
            }
        },
    },
    mounted() {
        this.switchList('users')
    }
}

</script>

<style scoped>

</style>
